export const firebaseConfig = {
  apiKey: "AIzaSyCBg6f_0DyggJ9eAHGOH_ntqJ3jdQ7qcks",
  authDomain: "painguide-57531.firebaseapp.com",
  databaseURL: "https://painguide-57531.firebaseio.com",
  projectId: "painguide-57531",
  storageBucket: "painguide-57531.appspot.com",
  messagingSenderId: "756149832034"
};
